import { Box, Button, Grid } from '@mui/material';
import { IComponentCss, PeriodSelectType } from '@tap/mui-ui';
import { IssueCreatedAndResolvedTaskComparisonReportResult } from '@tap/data-providers';
import CreatedAndResolvedTaskComparisonChart from './CreatedAndResolvedTaskComparisonChart';
import CreatedAndResolvedTaskComparisonTable from './CreatedAndResolvedTaskComparisonTable';

/* Таблица Отчет "Созданные vs Завершённые заявки"
*/

// Стили
const css: IComponentCss = {
    contentWrap: {
        position: 'relative',
        display: 'inline-grid',
        width: '100%',
    },
    optionsButton: {
        marginBottom: '5px',
        float: 'right',
    },
    chartWrap: {
        width: '90%',
        marginBottom: '40px',
    },
};

type CreatedAndResolvedTaskComparisonReportProps = {
    periodType: PeriodSelectType,
    calculationData: IssueCreatedAndResolvedTaskComparisonReportResult[],
    onOptionsButtonClick: () => void,
}


export default function CreatedAndResolvedTaskComparisonReport({ periodType, calculationData, onOptionsButtonClick }: CreatedAndResolvedTaskComparisonReportProps) {

    return (
        <>
            <Box sx={css.contentWrap}>
                <Grid>
                    <Button
                        size='small'
                        sx={css.optionsButton}
                        onClick={onOptionsButtonClick}
                    >
                        Параметры отчёта
                    </Button>
                </Grid>
                <Grid sx={css.chartWrap}>
                    <CreatedAndResolvedTaskComparisonChart
                        initialData={calculationData}
                        periodType={periodType}
                    />
                </Grid>
                <CreatedAndResolvedTaskComparisonTable initialData={calculationData} />
            </Box>
        </>
    );
}

